import {faBarsSort} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';

import {Locale} from '../../../../provider/locale/locale';
import {classNames} from '../../../../util/css';

import * as styles from './reviews-header.scss';

type PropsType = {
    isDesktop: boolean;
    isSorted: boolean;
    onClick: () => void;
};

export function ReviewsHeaderSortButton(props: PropsType): JSX.Element {
    const {isDesktop, isSorted, onClick} = props;

    return (
        <Button
            className={classNames(
                styles.ReviewsHeader_sortingButton,
                !isDesktop ? styles.ReviewsHeader_sortingButton_iconOnly : ''
            )}
            // eslint-disable-next-line no-undefined
            icon={<FontAwesomeIcon flip={!isSorted ? 'vertical' : undefined} icon={faBarsSort} />}
            onClick={onClick}
            type="default"
        >
            {isDesktop && <Locale stringKey={isSorted ? 'REVIEWS__NEW' : 'REVIEWS__OLD'} />}
        </Button>
    );
}
